module.exports = __webpack_public_path__ + "img/demo99.840fde6f.png";